export default "__VITE_ASSET__7b611e18__"